import { FC, Fragment } from "react";
import { getDomainCreationFields } from "../../variables/textFields";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";
import { FormContainer } from "../../../../../shared/components/formContainer";
import { Grid } from "@mui/material";
import InputTextfield from "../../../../../shared/components/textField";
import { useFormik } from "formik";
import { customizeDomainValidationSchema } from "../../variables/customSchema";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import ResellerConnectWidget from "../components/ResellerConnectWidget";

interface DomainNameProps {
  organizationId: string;
  domainName: string;
  entityPermissions: string[];
  fetchData: Function;
}

const DomainList: FC<DomainNameProps> = ({
  organizationId,
  domainName,
  fetchData,
  entityPermissions,
}) => {
  const { loading: apiLoading, modifyData } = useMutation("");

  const initialValues = {
    domainName: domainName,
    organizationId,
  };

  const textFields = getDomainCreationFields({});

  const domainForm = useFormik({
    initialValues: initialValues,
    validationSchema: customizeDomainValidationSchema(),
    enableReinitialize: true,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (formData: any) => {
      const res = await modifyData(
        `/admin/organization/update-domain`,
        "put",
        {
          ...formData,
        },
        domainForm
      );
      if (res) fetchData();
    },
  });
  console.log(domainForm);
  const titleBar = {
    headerTitle: "Reseller",
    title: " ",
    buttonTitle: "Save",
    disabled:  entityPermissions
    ? !entityPermissions?.includes("Reseller-Create")
    : false,
    onClick: () => domainForm.handleSubmit(),
    dirty: domainForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      <ProfileBorderBox>
        {!domainName ? (
          <FormContainer titleBar={titleBar}>
            <Grid
              container
              alignItems="stretch"
              columnSpacing={4}
              rowSpacing={2}
              mt={1}
            >
              {textFields.map((field: any, index: number) => (
                <Fragment key={field.id}>
                  {(field?.formField === undefined ||
                    field.formField === true) && (
                    <Grid item md={6} sm={6} xs={12}>
                      <InputTextfield
                        form={domainForm}
                        fieldProps={field}
                        key={index}
                      />
                    </Grid>
                  )}
                </Fragment>
              ))}
            </Grid>
          </FormContainer>
        ) : (
          <Grid container spacing={2} justifyContent="center" my={4}>
            <Grid item md={8} sm={8} xs={12}>
              <ResellerConnectWidget domainName={domainName || ""} />
            </Grid>
          </Grid>
          // <Grid item md={6} sm={6} xs={12}>
          //   <Typography variant="subtitle1">
          //     <strong>Domain:</strong> {domainName}
          //   </Typography>
          // </Grid>
        )}
      </ProfileBorderBox>
    </>
  );
};

export default DomainList;
